"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var style_1 = require("@lyearn/style");
function SvgCheckmarkOutline(_props, svgRef) {
    var props = (0, style_1.useSvg)(_props);
    return (React.createElement("svg", tslib_1.__assign({ width: 24, height: 24, viewBox: "0 0 24 24", ref: svgRef }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.863 18a1 1 0 01-.729-.315l-4.863-5.179a1 1 0 111.457-1.369l4.125 4.391 8.408-9.202a1 1 0 011.477 1.348l-9.137 10a.998.998 0 01-.73.326h-.008z" })));
}
exports["default"] = React.forwardRef(SvgCheckmarkOutline);
//# sourceMappingURL=CheckmarkOutline.js.map